/** 多字詞的字形字級：一字最大，字愈多愈小，永遠單行置中（修 2026-10-28 三字詞在字靈球內換行溢出）。 */
export function glyphPx(w: string, base: number): number {
  const n = Array.from(w).length;
  if (n <= 1) return base;
  if (n === 2) return Math.round(base * 0.6);
  if (n === 3) return Math.round(base * 0.44);
  if (n === 4) return Math.round(base * 0.34);
  return Math.round(base * 0.28);
}
